export default "__VITE_ASSET__DKTRAwQu__"